import {isEmpty} from 'lodash';
import url from 'url';
import { PRODUCTION_HOST } from '../constants';

export function redirectToPath(path) {
  window.location = path;
}

export function forceHTTP(url) {
  if (isEmpty(url)) { return ''; }
  return 'http:' + url.replace(/.*?:\/\//g, '//');
}

export function forceHTTPS(url) {
  if (isEmpty(url)) { return ''; }
  return 'https:' + url.replace(/.*?:\/\//g, '//');
}

export function fullURLofPath(path, location) {
  // wrap each call to fullURLofPath with forceHTTPS instead of doing here incase of specific instances that don't need it
  if (isEmpty(path) || isEmpty(location)) { return ''; }
  if (path.indexOf('://') > 0) { return path; } // if a full url happens to be passed in just return it as is

  // url.resolve will handle if the path excludes the leading slash
  return url.resolve(location.protocol + '//' + location.hostname, path);
}

export function getAbsolutePath(path, edition_data) {
  const { domain, basename } = edition_data;
  return `https://${domain}/${basename}${path}`;
}

export function getRelativePath(path, edition_data) {
  const { basename } = edition_data;

  if (path.startsWith(`/${basename}/`)) {
    return path;
  }

  return `/${basename}${path}`;
}

export const forceProductionDomainUrl = (link: ?string): string|null => {
  if (!link) {
    return null;
  }

  const parsedUrl = url.parse(link);
  return `${PRODUCTION_HOST}${parsedUrl.pathname}`;
};
